module.exports = __webpack_public_path__ + "img/E-WEB-Goal-01.089e61dc.svg";